export enum StatusGroups {
  Aktive = 1,
  Prosjektering = 4,
}

export enum Modules {
  AppAdmin = -100,

  DokflytSaksbehandler = 1,
  Partner = 4,
  Byggestrom = 5,
  Timer = 6,
  Ressurs = 7,
  VaktOgBeredskap = 8,
  Veilys = 9,
  Utstyr = 10,
  Henvendelse = 12,
  Vedlikehold = 13,
  Energi = 14,
  Ett = 15,
  Arkiv = 16,
  Oversiktsliste = 17,
  Public = 18,
  Admin = 19,
  Analyse = 21,
  Telekom = 22,
  KommunePartner = 23,
  KommuneOppdrag = 24,
  Jernbane = 25,
  NVDBVegreferanse = 26,
  Innmåling = 27,
  Geobilder = 28,
  Elektro = 29,
  Innsikt = 30,
  Internkontroll = 31,
  Sluttkontroll = 32,
}

export enum Roles {
  Admin = 1,
  AppOwner = 2,
  Saksbehandler = 3,
  RessursAnsvarlig = 9,
}

export enum Storage {
  SuggestedProjects = 'SuggestedProjects',
}

export enum RegistrationStatusIds {
  Created = 100,
  Rejected = 150,
  FeedbackSent = 160,
  Approved = 200,
  TransferReady = 300,
  TransferFailed = 320,
  TransferReceived = 350,
  TransferSuccess = 400,
  TransferSuccessManual = 420,
}

export enum ProjectTypes {
  Administrasjon = 11,
  AdminIntegrasjon = 78,
  Ressurs = 62,
  EquipmentBooking = 108,
}

export enum ProjectProperties {
  RessursPrioritet = 54,
  RessursKommentar = 55,
  PlanlagtStart = 64,
  PlanlagtFerdig = 66,
  RessursTidsbruk = 67,
  RessursMontør = 68,
}

export enum TenantFeatures {
  OutlookIntegration = 'ExternalOutlook',
}

export enum Tenants {
  Dragefossen = 647,
  VikenEnergiMontasje = 14,
  Linja = 487,
}
